import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NamingToolTable from './components/NamingToolTable';
import './index.css';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/file-naming"
          element={
            <ProtectedRoute>
              <NamingToolTable />
            </ProtectedRoute>
          }
        />
        {/* Redirect legacy root to new main route */}
        <Route path="/" element={<Navigate to="/file-naming" replace />} />
        <Route path="*" element={<div className="p-10 text-center text-gray-600 font-medium">Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;